// extracted by mini-css-extract-plugin
module.exports = {"title":"SuggestionsComplains_title__2W-wI","para":"SuggestionsComplains_para__1z8sr"};